export const Name = 'declarationViewSkeletonComponent';
